// views/auth/register.js  (PT-BR)
export const register_i18n = {
  alts: { banner: "fundo de cadastro", brand: "WA Checkin", footerLogo: "WA Checkin" },
  aria: { toggleReferral: "ativar ou desativar o código de afiliado", togglePassword: "mostrar ou ocultar a senha" },
  texts: {
    inviteTitle: "Parabéns!",
    inviteText: "{name} convidou você para a WACheckin: você ganha {percent}% de desconto nos primeiros {months} meses.",
    inviteApplied: "Aplicado a partir do seu link de convite.",
    panelKicker: "WACHECKIN · 2026",
    panelCta: "Conheça o WACheckin",
    langLabel: "Idioma",
    panelTitle: "Configure uma vez. O resto anda sozinho.",
    panelDesc:
      "O link do check-in, a boas-vindas, as chaves e o aviso às autoridades saem sem você precisar lembrar.",
    title: "Crie sua conta",
    infoTitle: "Cadastre-se em minutos",
    infoDesc:
      "Complete seus dados e comece a automatizar o check-in e a comunicação com seus hóspedes.",
    referralHint: "Ative apenas se lhe deram um.",
    alreadyHaveAccount: "Já tem uma conta?",
  },
  labels: {
    inviteCode: "Código de convite",
    name: "Nome",
    email: "E-mail",
    password: "Senha",
    phone: "Telefone",
    referralCode: "Código de afiliado",
  },
  placeholders: {
    name: "Digite seu nome",
    email: "Digite seu e-mail",
    password: "Crie uma senha",
    referralCode: "Código",
  },
  buttons: { submit: "Criar conta", submitting: "Criando conta...", signIn: "Entrar" },
  validation: { phoneRequired: "Escreva o seu número, não apenas o indicativo.", phoneInvalid: "Esse número não é válido. Verifique.", invalidReferralCode: "O código de afiliado não é válido." },
  toast: {
    signupSuccess: "Conta criada com sucesso!",
    signupError: "Não foi possível se cadastrar.",
    networkError: "Erro de conexão. Tente novamente.",
    referralCodeError: "O código de afiliado não é válido.",
  },
};
